<!-- Cookie -->
@if ((bareApp$ | async) === false) {
<bpc-cookie-banner #cookieComponent (visibleChanged)="onCookieVisibilityChange($event)"
	(acceptCookies)="onUserAcceptedCookies($event)"></bpc-cookie-banner>
}
<!-- Authorization -->
<auth-lib></auth-lib>
@if ((bareApp$ | async) === false) {
<ng-progress></ng-progress>

@if (!getUser()?.isLoggedIn) {
<div class="main-content blur-wrapper">
	<div class="bp-navbar-public">
		<div class="bp-navbar-public-logo-container">
			<a class="bp-navbar-public-logo" [href]="baseUrl" [tabIndex]="-1">
				<img src="assets/images/logo_bitpanda.svg" [alt]="'bitpanda_logo_alt_text' | translate" height="40"
					width="139" />
			</a>
		</div>
		<ul class="bp-navbar-public-links-container">
			<li class="bp-navbar-public-links-item">
				<a class="bp-navbar-public-link" target="_blank" [href]="supportUrl">
					{{ "help_center" | translate }}
				</a>
			</li>
			<li class="bp-navbar-public-links-item">
				<a class="bp-navbar-public-link" target="_blank" href="https://blog.bitpanda.com/">
					{{ "blog" | translate }}
				</a>
			</li>
			<li class="bp-navbar-public-links-item">
				<a class="bp-navbar-public-link">
					{{ getLanguage() }}
					<span class="bpi__icon-caret-down"></span>
				</a>
				<ul class="bp-navbar-public-secondary-nav">
					@for (lang of getLanguages(); track lang) {
					<li class="bp-navbar-public-secondary-nav-item">
						<a class="bp-navbar-public-secondary-nav-link" (click)="setLanguage(lang)">
							{{ getLanguageIsoCode(lang) | uppercase }}
						</a>
					</li>
					}
				</ul>
			</li>
			<a class="bp-navbar-button mod-inverse" [routerLink]="['/user/' + (isLogin() ? 'register' : 'login')]">
				{{ (isLogin() ? "register_button" : "login_button") | translate }}
			</a>
		</ul>
	</div>
	<div class="container-public-content">
		<router-outlet></router-outlet>
	</div>
</div>
}
}
@if (getUser()?.isLoggedIn) {
<bp-content class="blur-wrapper" [ngClass]="{ 'no-overflow': isOverlayOpen }" (click)="untoggleProfile()">
	@if ((bareApp$ | async) === false && (showGlobalBanner$ | async)) {
	<global-warning></global-warning>
	}
	@if ((bareApp$ | async) === false && (isInitiated() | async)) {
	<header class="bp-navbar mod-fixed-top"
		[ngClass]="{ 'is-open': isMainToggled(), 'is-hidden': isHidden(), 'no-overflow': isOverlayOpen }">
		<div class="bp-navbar-inner">
			<!-- Brand and toggle get grouped for better mobile display -->
			<span class="bp-navbar-toggle-click" (click)="toggleMain(false)">
				<a class="bp-navbar-mobile-nav-toggler">
					<span></span>
					<span></span>
				</a>
			</span>
			<span [routerLink]="['home']" [tabindex]="10000" class="bp-navbar-brand invert-svg-fill"
				[scrollToTop]="true"></span>
			<!-- Collect the nav links, forms, and other content for toggling -->
			<nav class="bp-navbar-main">
				<div class="bp-navbar-left">
					<ul class="bp-navbar-nav">
						<li class="bp-navbar-nav-item">
							<a class="bp-navbar-nav-link" (click)="toggleMain(false)" [routerLink]="['home']"
								[tabindex]="10001" routerLinkActive="is-active" [scrollToTop]="true">
								{{ "home" | translate }}
							</a>
						</li>
						<li class="bp-navbar-nav-item">
							<a class="bp-navbar-nav-link" (click)="toggleMain(true)" [routerLink]="['portfolio']"
								[tabindex]="10002" routerLinkActive="is-active" [scrollToTop]="true">
								{{ "portfolio_title" | translate }}
							</a>
						</li>
						<li class="bp-navbar-nav-item">
							<a class="bp-navbar-nav-link" (click)="toggleMain(false)" [routerLink]="['discover']"
								[tabindex]="10003" routerLinkActive="is-active" [scrollToTop]="true">
								{{ "discover" | translate }}
							</a>
						</li>
						@if(showFusionTopEntryPoint$ | async) {
						<li class="bp-navbar-nav-item">
							<a class="bp-navbar-nav-link" (click)="openFusionModal()">
								Fusion
							</a>
							@if (showFusionTooltip) {
							<div class="info-text info-text-bottom">
								<div class="text-container">
									<p class="title">{{ "fusion_tooltip_title" | translate }}</p>
									<p class="subtitle">{{ "fusion_tooltip_subtitle" | translate }}</p>
								</div>
								<div class="icon-container">
									<svg-inline (click)="dismissFusionTooltip()" class="dismiss-icon"
										src="/assets/images/dismiss-shape.svg" alt="image-icon" />
								</div>
							</div>
							}
						</li>
						}
					</ul>
				</div>
				<div class="bp-navbar-right">
					<div class="bp-navbar-button-group" role="group">
						<a (click)="tradeInit()" (keydown.enter)="tradeInit()" [tabindex]="10500"
							class="bp-navbar-button">
							<span class="bpi__icon-trade"></span>
							{{ "trade" | translate }}
						</a>
						<a (click)="deposit()" (keydown.enter)="deposit()" [tabindex]="10501"
							routerLinkActive="is-active" class="bp-navbar-button">
							<span class="bpi__icon-incoming"></span>
							{{ "nav-button-deposit" | translate }}
						</a>
					</div>
					<a (click)="send()" (keydown.enter)="send()" [tabindex]="10502"
						class="bp-navbar-button mod-inverse mod-standalone">
						<span class="bpi__icon-send"></span>
						{{ "navbar_button_send_coins" | translate }}
					</a>
				</div>
			</nav>
			<!-- notifications bell -->
			<div class="profile-and-notifications">
				@if (isNotificationActive$ | async) {
				<notification-bell (isOverlayOpen)="onOverlayOpen()"> </notification-bell>
				}
				<!-- .navbar-collapse -->
				@if (userMembership$ | async; as userMembership) {
				<div class="bp-navbar-profile" [ngClass]="{ 'is-open': isProfiletoggled() }">
					<a class="bp-navbar-profile-toggler" (click)="toggleProfile($event)">
						<bp-profile-picture [membership]="userMembership.clubLevel"
							[userStatus]="getUser().getVerified()" logo="/assets/images/panda-grey.svg"
							cssClass="app-container" [tabindex]="10503"
							(keydown.enter)="toggleProfile()"></bp-profile-picture>
					</a>
					@if (verificationState$ | async; as state) {
					<div class="bp-navbar-account-overlay" [ngClass]="{ 'mod-not-verified': state.isNotYetVerified }">
						<div class="bp-navbar-account-overlay-inner">
							<div class="bp-navbar-account-overlay-button-display">
								<div class="bp-navbar-account-overlay-verification-status">
									<bp-profile-picture [membership]="userMembership.clubLevel"
										[userStatus]="getUser().getVerified()" cssClass="app-container">
									</bp-profile-picture>
									@if (profile$ | async; as profile) {
									<div class="bp-navbar-account-overlay-verification-status-content">
										<div class="font-size-15 text-full-word-break font-semibold">
											{{ profile.fullName }}
										</div>
										<div class="font-size-13 text-full-word-break email-information">
											{{ profile.email }}
										</div>
										@if (profile.business.length > 0) {
										<div class="font-size-13 text-overflow-ellipsis business-information">
											{{ profile.business }}
										</div>
										}
									</div>
									}
								</div>
								<!-- Removing Fusion is needed for UK -->
								<!-- @if (showAdvancedTradingBanner$ | async) {
								<div class="adv-trading-small-banner">
									<adv-trading-entry-point (click)="openFusionModal()"></adv-trading-entry-point>
								</div>
								} -->
								@if (state.showVerifyButton) {
								<div class="pb-25 ml-25 mr-25">
									<a class="btn verify-now word-break-whitespace" [tabindex]="10600"
										(click)="verify()" (keydown.enter)="verify()">
										<span class="bpi__icon-verify iconcenter-vertical font-size-17"></span>
										<span>{{ "dashboard_banner_verify_now" | translate }}</span>
									</a>
								</div>
								}
							</div>
							<nav class="bp-navbar-account-overlay-links-big">
								<a class="bp-navbar-account-overlay-link" [routerLink]="['/my-account']"
									[tabindex]="10601" routerLinkActive="is-active" [scrollToTop]="true">
									<bp-icon class="bp-navbar-account-overlay-link__icon" size="24" icon="person"
										theme="regular"></bp-icon>
									<span class="bp-navbar-account-overlay-link__label">
										{{ "navbar_dropdown_profile" | translate }}
									</span>
								</a>
								<a class="bp-navbar-account-overlay-link" [routerLink]="['/my-account/security']"
									[tabindex]="10602" routerLinkActive="is-active" [scrollToTop]="true">
									<bp-icon class="bp-navbar-account-overlay-link__icon" size="24" icon="lock"
										theme="regular"></bp-icon>
									<span class="bp-navbar-account-overlay-link__label">
										{{ "navbar_dropdown_security_settings" | translate }}
									</span>
								</a>
								<a class="bp-navbar-account-overlay-link" [routerLink]="['/my-account/settings']"
									[tabindex]="10603" routerLinkActive="is-active" [scrollToTop]="true">
									<bp-icon class="bp-navbar-account-overlay-link__icon" size="24" icon="settings"
										theme="regular"></bp-icon>
									<span class="bp-navbar-account-overlay-link__label">
										{{ "navbar_dropdown_settings" | translate }}
									</span>
								</a>
								<a class="bp-navbar-account-overlay-link" [routerLink]="['/my-account/history']"
									[tabindex]="10604" routerLinkActive="is-active" [scrollToTop]="true">
									<bp-icon class="bp-navbar-account-overlay-link__icon" size="24" icon="history"
										theme="regular"></bp-icon>
									<span class="bp-navbar-account-overlay-link__label">
										{{ "navbar_dropdown_history" | translate }}
									</span>
								</a>
								<!-- Removing BEST is needed for UK -->
								<!-- @let phase = phase$ | async;
								@if (
								phase?.phase === web3MergePhase.Merge ||
								phase?.phase === web3MergePhase.PostMerge
								) {
								<a class="bp-navbar-account-overlay-link" [routerLink]="['/my-account/my-vision']"
									[tabindex]="10605" routerLinkActive="is-active" [scrollToTop]="true">
									<svg-inline class="bp-navbar-account-overlay-link__icon" width="24" height="24"
										src="assets/images/web3/vsn.svg" alt="Vision" />
									<span class="bp-navbar-account-overlay-link__label">
										{{ "navbar_dropdown_my_vision" | translate }}
									</span>
								</a>
								} @else {
								<a class="bp-navbar-account-overlay-link" [routerLink]="['/my-account/my-best']"
									[tabindex]="10605" routerLinkActive="is-active" [scrollToTop]="true">
									<bp-icon class="bp-navbar-account-overlay-link__icon" size="24" icon="best"
										theme="regular"></bp-icon>
									<span class="bp-navbar-account-overlay-link__label">
										{{ "navbar_dropdown_my_best" | translate }}
									</span>
								</a>
								} -->
								<a (click)="setStakingOverviewFlow()" class="bp-navbar-account-overlay-link staking"
									[routerLink]="['/my-account/staking-overview']" [tabindex]="10606"
									routerLinkActive="is-active" [scrollToTop]="true"
									*featureVisibility="featureList.STAKING">
									<bp-icon class="bp-navbar-account-overlay-link__icon" size="24" icon="stake"
										theme="regular"></bp-icon>
									<span class="bp-navbar-account-overlay-link__label">
										{{ "staking" | translate }}
									</span>
								</a>
								<a class="bp-navbar-account-overlay-link savings" [routerLink]="['/my-account/savings']"
									[tabindex]="10607" routerLinkActive="is-active" [scrollToTop]="true">
									<svg-inline class="bp-navbar-account-overlay-link__icon"
										alt="{{ 'savings' | translate }}" src="assets/images/savings_icon.svg" />
									<span class="bp-navbar-account-overlay-link__label">
										{{ "navbar_dropdown_savings" | translate }}
									</span>
								</a>
								<!-- Removing CARD is needed for UK -->
								<!-- <a class="bp-navbar-account-overlay-link savings" [routerLink]="['/my-account/card']"
									[tabindex]="10608" routerLinkActive="is-active" [scrollToTop]="true">
									<bp-icon class="bp-navbar-account-overlay-link__icon" size="24" icon="payment"
										theme="regular"></bp-icon>
									<span class="bp-navbar-account-overlay-link__label">
										{{ "navbar_dropdown_card" | translate }}
									</span>
								</a> -->
								<a class="bp-navbar-account-overlay-link savings" [routerLink]="['/my-account/reports']"
									[tabindex]="10608" routerLinkActive="is-active" [scrollToTop]="true">
									<bp-icon class="bp-navbar-account-overlay-link__icon" size="24" icon="document"
										theme="regular"></bp-icon>
									<span class="bp-navbar-account-overlay-link__label">
										{{ "reports_and_statements" | translate }}
									</span>
								</a>
								<a class="bp-navbar-account-overlay-link" [routerLink]="['/my-account/contacts']"
									[tabindex]="10609" routerLinkActive="is-active" [scrollToTop]="true">
									<bp-icon class="bp-navbar-account-overlay-link__icon" size="24" icon="book-contacts"
										theme="regular"></bp-icon>
									<span class="bp-navbar-account-overlay-link__label">
										{{ "address_book" | translate }}
									</span>
								</a>
								<a class="bp-navbar-account-overlay-link" [routerLink]="['/my-account/apikey']"
									[tabindex]="10610" routerLinkActive="is-active" [scrollToTop]="true">
									<bp-icon class="bp-navbar-account-overlay-link__icon" size="24"
										icon="plug-disconnected" theme="regular"></bp-icon>
									<span class="bp-navbar-account-overlay-link__label">
										{{ "navbar_dropdown_apikey" | translate }}
									</span>
								</a>
							</nav>
							<nav class="bp-navbar-account-overlay-links-small">
								@if (getUser()?.isAffiliate()) {
								<a class="bp-navbar-account-overlay-link-small" [tabindex]="10611"
									[routerLink]="['/my-account/affiliate']" [scrollToTop]="true">
									{{ "affiliate_navigation_link" | translate }}
								</a>
								}
								<!-- Removing TELL-A-FRIEND is needed for UK -->
								<!-- @if (!getUser()?.isAffiliate()) {
								<a class="bp-navbar-account-overlay-link-small" [tabindex]="10612"
									[routerLink]="['/my-account/tell-a-friend']" [scrollToTop]="true">
									{{ "tell_a_friend" | translate }}
								</a>
								} -->
								<a class="bp-navbar-account-overlay-link-small" [tabindex]="10613" target="_blank"
									[href]="baseUrl + 'app-ios-android'">
									{{ "app_link_navigation" | translate }}
								</a>
								<a class="bp-navbar-account-overlay-link-small" [tabindex]="10614" target="_blank"
									[href]="supportUrl">
									{{ "contact_support_menu_item" | translate }}
								</a>
								<a class="bp-navbar-account-overlay-link-small mobile-only" [tabindex]="10615"
									[routerLink]="['/my-account/terms-privacy']" [scrollToTop]="true">
									{{ "terms-privacy" | translate }}
								</a>
								<a class="bp-navbar-account-overlay-link-small" [tabindex]="10616" target="_blank"
									[href]="baseUrl + 'legal/legal-notice'">
									{{ "imprint_link" | translate }}
								</a>
							</nav>
							<nav class="bp-navbar-account-overlay-links-big mod-logout">
								<a (click)="logout()" [tabindex]="10617" class="bp-navbar-account-overlay-link">
									<span class="bp-navbar-account-overlay-link__icon bpi__icon-logout"></span>
									<span class="bp-navbar-account-overlay-link__label">
										{{ "navbar_dropdown_logout" | translate }}
									</span>
								</a>
							</nav>
						</div>
					</div>
					}
				</div>
				}
			</div>
		</div>
	</header>
	}
	<main id="main-app-container" class="app-container"
		[ngClass]="{ 'dark-surface': isDarkSurfaceAppContainer, 'bare-app': (bareApp$ | async) }">
		<!-- .navbar.navbar-default -->
		<router-outlet></router-outlet>
	</main>
</bp-content>
}


@if (!isOffline() && getUser()?.isLoggedIn) {
<loading-screen
	[visibleByCondition]="(isInitiated() | async) === false && !hasAuthFailure() && (bareApp$ | async) === false">
</loading-screen>
}

<modal-collection></modal-collection>


@if (isOldIE()) {
<div class="update-browser-info">
	<a style="position: absolute; top: 1em; right: 1em" (click)="ignoreOldIE()">
		{{ "close" | translate }}
		<span class="bpi__icon-close-round"></span>
	</a>
	<div class="update-browser-info-content">
		<div class="update-browser-info-image-container">
			<img class="update-browser-info-image img-responsive" src="/assets/images/sad-panda.svg"
				[alt]="'not_supported_browser_alt_text' | translate" />
		</div>
		<h3 class="update-browser-info-headline">{{ "browser_out_of_date" | translate }}</h3>
		<div class="update-browser-info-text">{{ "browser_out_of_date_desc" | translate }}</div>
		<div class="text-center">
			<a class="btn btn-primary" href="http://outdatedbrowser.com" target="_blank">
				{{ "find_out_more" | translate }}
			</a>
		</div>
	</div>
</div>
}
@if ((bareApp$ | async) === false) {
@if (isOnfidoEligible()) {
<onfido></onfido>
}
}
<!-- Modal Module route outlet container -->
<modal-holder [forOutlet]="false"></modal-holder>
<router-outlet name="modal"></router-outlet>